/** 公開アプリ URL と招待コードから受け手向けの招待リンクを組み立てる。 */
export function buildCommunityInviteUrl(
  publicAppUrl: string,
  code: string,
): string {
  const base = publicAppUrl.replace(/\/$/, '');
  const trimmed = code.trim();
  return `${base}/invite/${trimmed}`;
}
